<template>
  <!-- 首屏轮播图大容器 -->
  <UCarousel
    v-slot="{ item }"
    loop
    dots
    arrows
    :watch-drag="true"
    prev-icon="fe:arrow-left"
    next-icon="fe:arrow-right"
    :watch-resize="true"
    :items="carsouselItems"
    :ui="{
      root: '',
      container: 'flex ms-0 m-0',
      viewport: 'bg-black/90 m-0',
      prev: 'text-4xl lg:size-20 sm:-start-0 -start-0 hidden lg:flex justify-center ring-0 text-white hover:bg-black/40 active:bg-black/50',
      next: 'text-4xl lg:size-20 sm:-end-0 -end-0 hidden lg:flex justify-center ring-0 text-white hover:bg-black/40 active:bg-black/50',
      dots: 'lg:mb-14 mb-12',
    }"
  >
    <!-- 最大容器，含阴影层、内容层，背景图由最大容器设置。 -->
    <div
      :class="[
        'flex items-center justify-center relative',
        'bg-cover bg-center bg-no-repeat',
        'lg:min-h-[80vh] min-h-screen',
      ]"
    >
      <!-- 视频背景 -->
      <video
        v-if="isVideoStr(item)"
        autoplay
        muted
        loop
        playsinline
        poster="/img/bg/home-1.avif"
        :class="['absolute inset-0 size-full object-cover']"
      >
        <source :src="item" type="video/mp4" />
      </video>
      <!-- 图片背景 -->
      <div
        v-else
        :class="['absolute inset-0 size-full object-cover', 'bg_img']"
        :style="{
          backgroundImage: `url(${item})`,
        }"
      />
      <!-- 内容层-左右切分栅格容器 -->
      <div
        :class="[
          'page_view z-2',
          'grid lg:grid-cols-[48rem_1fr] grid-cols-1 lg:gap-x-24 gap-y-6 place-items-center',
          'text-white',
          'lg:pt-[calc(var(--ui-header-height)+8rem)] pt-[calc(var(--ui-header-height)+2rem)] lg:pb-32 pb-20',
        ]"
      >
        <!-- 左侧文字内容卡片 -->
        <div class="flex flex-col lg:gap-6 gap-4">
          <!-- 文字部分容器 -->
          <div class="select-none">
            <!-- 首屏大标题 -->
            <h1 class="lg:text-5xl md:text-3xl text-3xl w-fit lg:mb-3 mb-2 font-bold">
              {{ t('page.index.primary.title') }}
              <div class="bg_linear_to_r lg:h-2 h-[0.4rem] lg:mt-4 mt-2" />
            </h1>
            <!-- 副标题 -->
            <h2 class="lg:text-2xl md:text-lg text-lg lg:mb-2 mb-1 font-bold">
              {{ t('page.index.primary.subTitle') }}
            </h2>
            <!-- 正文 -->
            <p class="lg:text-lg md:text-sm text:sm">
              {{ t('page.index.primary.desc', { expYear: new Date().getFullYear() - 1995 }) }}
            </p>
          </div>

          <!-- 联络页跳转按钮 -->
          <!-- <CommonBtnPress
            :label="t('page.index.primary.getQuote')"
            :type="1"
            tralling-icon="octicon:triangle-right-24"
            @click="useLocalePush('/order/quote')"
          /> -->
          <CommonBtnPress
            :label="t('page.index.primary.getQuote')"
            :type="1"
            tralling-icon="octicon:triangle-right-24"
            @click="useLocalePush('/order/quote')"
          />
          <!-- <CommonBtnPress
            :label="t('page.index.primary.getQuote')"
            :type="3"
            tralling-icon="octicon:triangle-right-24"
            @click="useLocalePush('/order/quote')"
          /> -->

          <!-- 完整图标组容器 -->
          <div
            :class="[
              'flex flex-wrap items-center lg:justify-start justify-center lg:gap-4 gap-2',
              'whitespace-nowrap lg:text-lg text-sm',
              'cursor-default',
            ]"
          >
            <!-- 单组图标文字 -->
            <div
              v-for="(inconDescitem, index) in iconDescList"
              :key="`primary-icon-${index}`"
              class="flex gap-1 items-center justify-center"
            >
              <UIcon :name="inconDescitem.icon" :class="['lg:size-6 size-5']" />
              <p>{{ t(inconDescitem.text) }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 阴影层 -->
      <div
        class="absolute z-1 inset-0 lg:bg-transparent bg-black/40 lg:bg-linear-to-r from-black/70 to-transparent"
      />
    </div>
  </UCarousel>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
  const { storageConfigUI } = useAppStorage()

  /** 大屏轮播图 */
  const carsouselItems = ref<string[]>(['/img/bg/home-1.avif', '/img/bg/home-2.avif'])

  /** 判断一个字符串是否后缀是视频格式结尾 */
  const isVideoStr = (str: string) => {
    return str.endsWith('.mp4') || str.endsWith('.avi') || str.endsWith('.mov')
  }

  /** icon描述 */
  const iconDescList = [
    { text: 'page.index.primary.tag.expert', icon: 'mdi:shield-outline' },
    { text: 'page.index.primary.tag.efficient', icon: 'mdi:truck-outline' },
    { text: 'page.index.primary.tag.swift', icon: 'lsicon:lightning-outline' },
    { text: 'page.index.primary.tag.reliable', icon: 'ri:shake-hands-line' },
  ]

  onMounted(() => {
    if (storageConfigUI.value.homeVideo) {
      carsouselItems.value = [
        '/video/home/1 (13).mp4',
        '/video/home/1 (11).mp4',
        '/video/home/1 (1).mp4',
        '/video/home/1 (2).mp4',
        '/video/home/1 (3).mp4',
        '/video/home/1 (4).mp4',
        '/video/home/1 (5).mp4',
        '/video/home/1 (6).mp4',
        '/video/home/1 (7).mp4',
        '/video/home/1 (8).mp4',
        '/video/home/1 (9).mp4',
        '/video/home/1 (10).mp4',
        '/video/home/1 (12).mp4',
      ]
    }
  })
</script>
